import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Academic from "./pages/Academic";
import Lifeatgdgps from "./pages/Lifeatgdgps";
import AdmissionEnquary from "./pages/AdmissionEnquary";
import Career from "./pages/Career";
import Pagenotfound from "./pages/Pagenotfound";
import Login from "./pages/Login";
import Blog from "./pages/Blog";
import Contactus from "./pages/Contactus";
import FAQ from "../src/pages/admission/FAQ";
import AdmissionProcessPolicies from "./pages/admission/AdmissionProcessPolicies";
import OnlineModal from "./pages/admission/OnlineModal";
import Registration from "./pages/admission/Registration";
import DocumentsRequired from "./pages/admission/DocumentsRequired";
import FeeStructure from "./pages/admission/FeeStructure";
import SuccessStories from "./pages/admission/SuccessStories";
import CampusTour from "./pages/admission/CampusTour";
import SchoolProspectus from "./pages/admission/SchoolProspectus";
import Legacy from "./pages/about/Legacy";
import Chairman from "./pages/about/Chairman";
import Leadership from "./pages/about/Leadership";
import Principal from "./pages/about/Principal";
import Newslatter from "./pages/about/Newslatter";
import Collaboration from "./pages/about/Collaboration";

import WalktheCampus from "./pages/WalktheCampus";
import Legitmacy from "./pages/about/Legitmacy";
import Synergy from "./pages/about/Synergy";
import Proficiency from "./pages/about/Proficiency";
import Prospect from "./pages/about/Prospect";
import Foundational from "./events/Foundational";
import Preparatory from "./events/Preparatory";
import Middle from "./events/Middle";
import Secondary from "./events/Secondary";
import VideoGallery from "./events/VideoGallery";
import ImgGallery from "./events/ImgGallery";
import SRKAbout from "./pages/about/SRKAbout";
import OnlineAppointmentSystem from "./pages/doctorSpecial/OnlineAppointmentSystem";
import DynamicWebsite from "./pages/doctorSpecial/DynamicWebsite";
import CampaignLeadGeneration from "./pages/doctorSpecial/CampaignLeadGeneration";
import SocialMediaManagemant from "./pages/doctorSpecial/SocialMediaManagemant";
import DigitalMarketing from "./pages/doctorSpecial/DigitalMarketing";
import SEOYoutube from "./pages/doctorSpecial/SEOYoutube";
import GraphicDesign from "./pages/webDesign/GraphicDesign";
import LogoBranding from "./pages/webDesign/LogoBranding";
import CustomWebDesign from "./pages/webDesign/CustomWebDesign";
import WorpressDesign from "./pages/webDesign/WorpressDesign";
import Woocommerce from "./pages/webDesign/Woocommerce";
import CustomEcommerce from "./pages/webDesign/CustomEcommerce";
import WebAppsDevelopment from "./pages/webDevelopment/WebAppsDevelopment";
import MobileAppDevelopment from "./pages/webDevelopment/MobileAppDevelopment";
import SoftwareDevelopment from "./pages/webDevelopment/SoftwareDevelopment";
import SAASDevelopmentt from "./pages/webDevelopment/SAASDevelopmentt";
import Analytics from "./pages/360digitalMarketing/Analytics";
import LinkedInMarketing from "./pages/360digitalMarketing/LinkedInMarketing";
import Emailmarketing from "./pages/360digitalMarketing/Emailmarketing";
import ContentMarketing from "./pages/360digitalMarketing/ContentMarketing";
import SocialMediaReputationManagement from "./pages/360digitalMarketing/SocialMediaReputationManagement";
import SocialMediaMarketing from "./pages/360digitalMarketing/SocialMediaMarketing";
import Ppc from "./pages/360digitalMarketing/Ppc";
import SEOforSmallBusiness from "./pages/SEOservices/SEOforSmallBusiness";
import LocalSEO from "./pages/SEOservices/LocalSEO";
import SEOAudit from "./pages/SEOservices/SEOAudit";
import CustomSEO from "./pages/SEOservices/CustomSEO";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import RefundPolicy from "./pages/RefundPolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="" element={""}></Route>
          <Route path="/about-srk" element={<SRKAbout/>} />
          <Route path="/chairman-desk" element={<Chairman />} />
          <Route path="/principal-desk" element={<Principal />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/newsletter" element={<Newslatter />} />
          <Route path="/collaboration" element={<Collaboration />} />
          <Route path="/walk-the-campus" element={<WalktheCampus />} />

          <Route path="/academic" element={<Academic />} />
          <Route path="/lifeatgdgps" element={<Lifeatgdgps />} />
          <Route path="/admission" element={<AdmissionEnquary />}>
            <Route path="/admission/faq" element={<FAQ />} />
            <Route
              path="/admission/admission-process"
              element={<AdmissionProcessPolicies />}
            />
            <Route path="/admission/online-modal" element={<OnlineModal />} />
            <Route path="/admission/registration" element={<Registration />} />
            <Route
              path="/admission/documents-required"
              element={<DocumentsRequired />}
            />
            <Route path="/admission/fee-structure" element={<FeeStructure />} />
            <Route
              path="/admission/success-stories"
              element={<SuccessStories />}
            />
            <Route path="/admission/campus-tour" element={<CampusTour />} />
            <Route
              path="/admission/school-prospectus"
              element={<SchoolProspectus />}
            />
          </Route>
          <Route path="/career" element={<Career />} />
          <Route path="/login" element={<Login />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/contact" element={<Contactus />} />
          <Route path="/legitimacy" element={<Legitmacy />} />
          <Route path="/synergy" element={<Synergy />} />
          <Route path="/proficiency" element={<Proficiency />} />
          <Route path="/prospect" element={<Prospect />} />
          <Route path="/foundational" element={<Foundational />} />
          <Route path="/preparatory" element={<Preparatory />} />
          <Route path="/middle" element={<Middle />} />
          <Route path="/secondary" element={<Secondary />} />
          <Route path="/vid-gallery" element={<VideoGallery />} />
          <Route path="/img-gallery" element={<ImgGallery />} />

          {/* For Doctor */}
          <Route path="/online-appointment-system" element={<OnlineAppointmentSystem/>} />
          <Route path="/dynamic-web-apps" element={<DynamicWebsite/>} />
          <Route path="/lead-generation" element={<CampaignLeadGeneration/>} />
          <Route path="/online-reputation-management" element={<SocialMediaManagemant/>} />   
           <Route path="/digital-marketng-for-doctor" element={<DigitalMarketing/>} />  
           <Route path="/seo-youtube-for-doctor" element={<SEOYoutube/>} />  
            {/* Graphic Designing */}
            <Route path="/graphic-designing"  element={<GraphicDesign/>} />
             <Route path="/logo-designing"  element={<LogoBranding/>} />    
            <Route path="/custom-web-designing"  element={<CustomWebDesign/>} />
            <Route path="/wordpress-design"  element={<WorpressDesign/>} />
            <Route path="/woo-commerce-design"  element={<Woocommerce/>} />
            <Route path="/custom-e-commerce-design"  element={<CustomEcommerce/>} />

          {/* Web-App Development */}
            <Route path="/web-development"  element={<WebAppsDevelopment/>} />
            <Route path="/mobile-app-development"  element={<MobileAppDevelopment/>} />
            <Route path="/software-development"  element={<SoftwareDevelopment/>} />
            <Route path="/saas-development"  element={<SAASDevelopmentt/>} />

            {/* 360 Digital Marketing */}
            <Route path="/ppc"  element={<Ppc/>} /> 
            <Route path="/social-media-marketing"  element={<SocialMediaMarketing/>} />
            <Route path="/social-media-reputation-management"  element={<SocialMediaReputationManagement/>} />
            <Route path="/content-marketing"  element={<ContentMarketing/>} />
            <Route path="/email-marketing"  element={<Emailmarketing/>} />
            <Route path="/linkdin-marketing"  element={<LinkedInMarketing/>} />
            <Route path="/analytics"  element={<Analytics/>} />

            {/* SEO  */}
            <Route path="/seo-for-small-business"  element={<SEOforSmallBusiness/>} />
            <Route path="/local-seo-gmb"  element={<LocalSEO/>} />
            <Route path="/custom-seo-solution"  element={<CustomSEO/>} />
            {/* <Route path="/e-commerce-seo"  element={<Emailmarketing/>} /> */}
            <Route path="/seo-audit"  element={<SEOAudit/>} />
           {/*  <Route path="/analytics-reporting"  element={<Analytics/>} />
 */}
          <Route path="*" element={<Pagenotfound />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions/>} />
          <Route path="/refund-policy" element={<RefundPolicy/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
